import { createPlatformBridge, type PlatformBridge } from "@acto/taskpane/core/platform/messaging/bridge";
import type { PlatformPlugin } from "@acto/taskpane/core/platform/PlatformPlugin";
import { createPlatformEnv } from "./env";
import { detectPlatform } from "./detectPlatform";

export interface PlatformRuntimeResult {
  readonly bridge: PlatformBridge;
  readonly plugin: PlatformPlugin;
}

/**
 * Entry point that detects and boots the correct platform plugin, returning a
 * shared messaging bridge alongside plugin metadata.
 */
export async function bootPlatformRuntime(plugins: PlatformPlugin[]): Promise<PlatformRuntimeResult> {
  if (plugins.length === 0) {
    throw new Error("No platform plugins supplied.");
  }

  const env = createPlatformEnv();
  const bridge = createPlatformBridge();

  const plugin = await detectPlatform(plugins, env);
  console.debug("[Platform] selected plugin", { plugin: plugin.name });

  await plugin.boot(env);

  plugin.registerMessaging?.(bridge, env);

  return {
    bridge,
    plugin,
  };
}
